module.exports = __webpack_public_path__ + "static/media/TurtleLogo.25efaf75.logo";